import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { YesOrNo } from '../enums/yesOrNo';
import { YesOrNoOrSome } from '../enums/yesOrNoOrSome';

export interface IEvaluationDiagnosticReportValidated {
    afterwardsReferPatient: YesOrNo;
    reportHelpful: YesOrNoOrSome;
    reportInstructive: YesOrNoOrSome;
    requestId: string;
}

export const evaluationDiagnosticReportSchema: ISchemaContainer<IEvaluationDiagnosticReportValidated> = {
    schema: Koi.object({
        afterwardsReferPatient: Koi.koi().enum(YesOrNo),
        reportHelpful: Koi.koi().enum(YesOrNoOrSome),
        reportInstructive: Koi.koi().enum(YesOrNoOrSome),
        requestId: Koi.string().uuid(),
    }).options({ convert: false, presence: 'required' }),
};

export interface IEvaluationRequestItemValidated {
    otherwiseReferPatient: YesOrNo;
    requestId: string;
}

export const evaluationRequestItemSchema: ISchemaContainer<IEvaluationRequestItemValidated> = {
    schema: Koi.object({
        otherwiseReferPatient: Koi.koi().enum(YesOrNo),
        requestId: Koi.string().uuid(),
    }).options({ convert: false, presence: 'required' }),
};
